module.exports = __webpack_public_path__ + "VAGRoundedStd-Black.d6534ae8822529380668.svg";


//////////////////
// WEBPACK FOOTER
// /var/www/minhaloga-cliente/src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Black.svg
// module id = ../../../../../src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Black.svg
// module chunks = styles